import React, { Dispatch, SetStateAction } from 'react'

import { useNavigate } from 'react-router'

import { Button, Modal } from '../..'
import { useUser } from '../../../context'

import {
  ContainerWelcome,
  ContainerTop,
  ContainerBottom,
  Title,
  SubTitle,
  Description,
  ContainerButtos,
} from './styles'

const WelcomeModal = ({
  showModal,
  setShowModal,
}: {
  showModal: boolean
  setShowModal: Dispatch<SetStateAction<boolean>>
}) => {
  const navigate = useNavigate()
  const { user } = useUser()

  const handleClose = () => {
    localStorage.setItem('hasForm', 'true')
    setShowModal(!showModal)
  }
  return (
    <Modal onClose={handleClose}>
      <ContainerWelcome>
        <ContainerTop>
          <div>
            <img src="/assets/book-square.png" alt="icono ahh" />
          </div>
          <Title>Bienvenido {user?.name}</Title>
          <SubTitle>¿Nos conocemos un pelín más?</SubTitle>
          <Description>
            El Formulario sirve como guía para que vuestros profesores
            establezcan las estrategias de entrenamiento vocal que mas efectivas
            para ti.
          </Description>
        </ContainerTop>
        <ContainerBottom>
          <ContainerButtos>
            <Button
              onClick={handleClose}
              label="En otro momento"
              fontSize={14}
              fontWeight={600}
            />

            {user && (
              <Button
                onClick={() =>
                  navigate('/initial-form', {
                    state: {
                      userId: user.uid,
                    },
                  })
                }
                className="dark-grey"
                label="Continuar"
                fontSize={14}
                fontWeight={600}
              />
            )}
          </ContainerButtos>
        </ContainerBottom>
      </ContainerWelcome>
    </Modal>
  )
}

export default WelcomeModal
